// @vendors
import { useCallback, useEffect, useState } from "react";

// @utils
import { client } from "utils/prismic-helpers";

export default function usePrismicBySingle(customType) {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  const getInfo = useCallback(async () => {
    try {
      const response = await client.getSingle(customType);
      if (response) {
        setInfo(response.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getInfo();
  }, []);

  return { info, loading };
}
